import { PopoverPlacement } from "@idui/react-popover";
import { Button, ButtonGroup } from "@mui/material";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import { FC, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";
import { TOOLTIP_DELAY_BUTTONS, useIsMobile } from "@ryde/shared";

import { StarredButtonContext } from "./starred-button-context";
import { StarredIcon } from "./starred-icon";
import { optionStarredTranslationKeyByValue } from "./starred-utils";

export const StarredButtonGroup: FC = () => {
  const { isMobile } = useIsMobile();
  const { t } = useTranslation();
  const {
    anchorRef,
    handleButtonClick,
    togglePopover,
    starredDisplayMode,
    starredCount,
    isDataReloading,
  } = useContext(StarredButtonContext);
  const tooltipContent = useMemo(() => {
    return t(optionStarredTranslationKeyByValue(starredDisplayMode));
  }, [starredDisplayMode, t]);
  return (
    <ButtonGroup
      className="starred-dropdown"
      variant="outlined"
      size={isMobile ? "small" : "large"}
      ref={anchorRef}
    >
      <FramerTooltip
        content={tooltipContent}
        placement={PopoverPlacement.top}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <Button onClick={handleButtonClick} disabled={isDataReloading}>
          <StarredIcon starredDisplayMode={starredDisplayMode} />
          {starredCount && <strong>{starredCount}</strong>}
        </Button>
      </FramerTooltip>
      <Button
        size="small"
        onClick={togglePopover}
        className="starred-group-button"
        disabled={isDataReloading}
      >
        <ArrowDropDownIcon className="arrow-button" />
      </Button>
    </ButtonGroup>
  );
};
